// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Tabs-module--switcher--2Mbf4","active":"Tabs-module--active--31XFG"};